<template>
  <div class="login-record">
    <div class="header">
      <h2 class="mobile-title">手机号：{{ mobile }}</h2>
    </div>
    
    <div class="record-list">
      <div class="record-item header-row">
        <span>设备类型</span>
        <span>浏览器类型</span>
        <span>IP地址</span>
        <span>User Agent</span>
      </div>
      
      <div v-for="(record, index) in records" 
           :key="index" 
           class="record-item">
        <span>{{ record.deviceType || '-' }}</span>
        <span>{{ record.browserType || '-' }}</span>
        <span>{{ record.ipAddress || '-' }}</span>
        <span class="user-agent">{{ record.userAgent || '-' }}</span>
      </div>
      
      <div v-if="records.length === 0" class="no-data">
        暂无登录记录
      </div>
    </div>

    <button @click="clearRecords" class="clear-button">
      一键清除所有记录
    </button>
  </div>
</template>

<script>
import { ref, getCurrentInstance, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { useRoute,useRouter } from 'vue-router'

export default {
  setup() {
    const { proxy } = getCurrentInstance()
    const route = useRoute()
    const router = useRouter();
    
    const mobile = ref('')
    const records = ref([])
    

    const fetchLoginRecords = async () => {
      try {
        const response = await proxy.$tools.request('/login/queryLoginRecord', {
          reqBody: { mobile: mobile.value }
        })
        
        if (response.data.rspHead.returnCode === '00000000') {
          records.value = response.data.rspBody.loginRecordList || []
        } else {
          ElMessage.error('获取记录失败：' + response.data.rspHead.returnMsg)
        }
      } catch (error) {
        ElMessage.error('系统异常：' + error.message)
      }
    }

    const clearRecords = async () => {
      proxy.$confirm('确认清除所有登录记录？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const response = await proxy.$tools.request('/login/clearLoginRecord', {
          reqBody: { mobile: mobile.value }
        })
        
        if (response.data.rspHead.returnCode === '00000000') {
          ElMessage.success('清除成功')
          fetchLoginRecords()
        } else {
          ElMessage.error('清除失败：' + response.data.rspHead.returnMsg)
        }
      })
    }

    onMounted(() => {
      mobile.value = route.query.mobile || ''
      if (mobile.value) {
        fetchLoginRecords()
      } else {
        ElMessage.error('缺少手机号参数')
        router.back()
      }
    })

    return { mobile, records, clearRecords }
  }
}
</script>

<style scoped>
.login-record {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-title {
  color: #333;
  font-size: 18px;
}

.record-list {
  border: 1px solid #eee;
  border-radius: 4px;
  margin-bottom: 20px;
}

.record-item {
  display: grid;
  grid-template-columns: 100px 120px 150px 1fr;
  gap: 15px;
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
}

.header-row {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #666;
}

.user-agent {
  word-break: break-all;
  color: #666;
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #999;
}

.clear-button {
  width: 100%;
  padding: 12px;
  background-color: #ff4d4f;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.clear-button:hover {
  background-color: #ff7875;
}

@media (max-width: 768px) {
  .record-item {
    grid-template-columns: 1fr;
    padding: 10px;
  }
  
  .header-row {
    display: none;
  }
  
  .record-item span::before {
    content: attr(data-label);
    font-weight: 500;
    margin-right: 8px;
    color: #666;
  }
  
  .user-agent {
    grid-column: 1 / -1;
  }
}
</style>
